module.exports = __webpack_public_path__ + "img/eg-cn-03.2e4ea739.png";